// extracted by mini-css-extract-plugin
export default {"section":"Es-z","sectionTitle":"Fs-z","fieldWrapper":"Gs-z","formField":"Hs-z","disabled":"Is-z","formLabel":"Js-z"};